<template>
  <v-app app>
    <router-view></router-view>

    <vx-confirm-dialog ref="confirmDialog"/>

    <v-snackbar v-model="networkError" color="error" :timeout="3000">
      The server is offline, starting...
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="networkError = false">Close</v-btn>
      </template>
    </v-snackbar>

    <v-overlay :value="loading">
      <v-progress-circular color="primary" indeterminate size="100" width="10"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import ConfirmDialog from './components/shared/ConfirmDialog'

export default {
  name: 'App',
  components: {
    'vx-confirm-dialog': ConfirmDialog
  },
  data: () => ({
    networkError: false
  }),
  computed: {
    ...mapGetters('app', [
      'loading'
    ])
  },
  methods: {
    ...mapActions('app', [
      'init'
    ]),

    onNetworkError () {
      this.networkError = true
    }
  },
  mounted () {
    this.$root.$confirmDialog = this.$refs.confirmDialog // Asociar referencia global al ConfirmDialog

    this.$eventHub.$on('onNetworkError', this.onNetworkError)
  },
  created () {
    this.init()
  }
}
</script>

<style>
  html {
    overflow-y: hidden;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .noUnderline {
    text-decoration: none;
    color: inherit;
  }

  /* Necesario para fijar la lista de tabs de los modulos debajo del stepper, y desde css scoped no funciona*/
  .v-stepper__wrapper {
    overflow: visible !important;
  }

  /* Estilo SweetAlert */
  .swal2-popup {
    font-family: system-ui !important;
  }

  /* Toast Progress */
  .toast-progress {
    background-color: #FFF !important;
    opacity: 0.8 !important;
  }

  .greyTile {
    background: #e7e7e7;
  }

</style>
